import { mainnet, sepolia } from 'wagmi/chains';

export const SubgraphUrl = {
  [sepolia.id]:
    'https://api.studio.thegraph.com/query/56846/floor-v2-sepolia/version/latest',
  [mainnet.id]:
    process.env.NEXT_PUBLIC_GRAPH_URL ||
    'https://api.studio.thegraph.com/query/56846/floor-v2/version/latest',
};
